import React, { createContext, useState, useEffect, useMemo } from 'react'

export const DataContext = createContext();

export const DataContextProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true)
    const [isError, setIsError] = useState(false)
    const [hasFetched, setHasFetched] = useState(false)
    const [sectionsData, setSectionsData] = useState(null)
    const [sitename, setSitename] = useState(null)
    const [tagline, setTagline] = useState(null)
    const [rif, setRif] = useState(null)
    const [strings, setStrings] = useState(null)
    const [socials, setSocials] = useState(null)

    useEffect(() => {
        if (!hasFetched) {
            const data = window.mga_api;
            const url = `${data.url}?nonce=${data.action}&lang=${data.lang}`

            fetch(url, {
                method: "GET",
                headers: {
                    'X-WP-Nonce': data.nonce,
                }
            })
            .then(response => response.json())
            .then(response => {
                if (response.status === 200) {
                    const { name, tagline, socials, sections, rif, strings } = response.data
                    setSitename(name)
                    setTagline(tagline)
                    setSectionsData(sections)
                    setSocials(socials)
                    setRif(rif)
                    setStrings(strings)
                    setIsLoading(false)
                } else {
                    throw new Error(response.message)
                }
            })
            .catch((error) => {
                setIsError(true)
                setIsLoading(false)
            })

            setHasFetched(true)
        }
    }, [hasFetched])

    const value = useMemo(() => ({
        isLoading, 
        isError, 
        sectionsData, 
        sitename, 
        tagline, 
        rif, 
        strings,
        socials
    }), [isLoading, isError, sectionsData, sitename, tagline, rif, strings, socials])

    return (
        <DataContext.Provider value={value}>
            {children}
        </DataContext.Provider>
    )
}